import type { SalesModel } from '../../lib/salesModel'
import { InfoPanel } from './InfoPanel'
import { useMessages } from '@/i18n'
import { messages } from './messages'

// Текст — 1:1 с рефом (CourseSettingsDialog.tsx:331-347 в oa-studio-prototype).
const TEXT = { subscription: 'infoSubscription', free: 'infoFree' } as const

interface Props {
  model: Exclude<SalesModel, 'standalone'>
}

export const SalesModelInfoPanel = ({ model }: Props) => {
  const m = useMessages(messages)
  return (
    <InfoPanel>
      <p>{m[TEXT[model]]}</p>
    </InfoPanel>
  )
}
